import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    console.log('TweetsController connected')
  }

  async triggerCheck() {
    console.log('triggerCheck called')
    alert('Działa!')
  }
}
